'use strict';

import FeedMove from './feedmove';

class MoveW extends FeedMove {
    constructor(w: number | null = null) {
        super(null, null, null, w);
    }
}

export default MoveW;
